import {Component} from '@angular/core';
/**
 * \@title Basic expansion panel
 */
export class ExpansionOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'expansion-overview-example',
  templateUrl: 'expansion-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ExpansionOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ExpansionOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExpansionOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
